import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import '../../../../node_modules/lit-element/lit-element.js';

function renderLeafPromo(promo) {
    return promo
        ? x `<div class="promo"><p class="promo-title">${promo.title}</p><p class="promo-description">${promo.description}</p><a class="promo-link" href="${promo.cta.link}">${promo.cta.text}</a></div>`
        : null;
}

export { renderLeafPromo };
